import { z } from 'zod'

const partnerIdRegex = /^[A-Z]{2}$/
const airportCodeRegex = /^[A-Z]{3}$/
const commaSeparatorRegex = /^([A-Z]{3})(,[A-Z]{3})*$/
export const GetAirportsParamsSchema = z.object({
  searchString: z.string().default(''),
  fromAirport: z.string().regex(airportCodeRegex).optional(),
  partnerIds: z.string().regex(partnerIdRegex, {
    message: 'Invalid partnerId',
  }),
  airportCodes: z
    .string()
    .regex(commaSeparatorRegex, {
      message: 'Invalid list of airportCodes',
    })
    .optional(),
})
export const GetAirportSchema = z.object({
  airportCode: z.string().refine((value) => new RegExp(airportCodeRegex).test(value), {
    message: 'Invalid airportCode',
  }),
})

export const DestinationSchema = z.object({
  id: z.string().min(1),
  type: z.string().min(1),
  fullName: z.string().min(1),
  name: z.string().min(1).optional(),
})

export type Destination = z.infer<typeof DestinationSchema>
